import { FnAxiosInstance } from '../axios';

export const getUnreadSecureMessageCount = async () => {
  const url = 'messages/poll-summary';
  const response = await FnAxiosInstance.get(url);
  return response?.data || [];
};
